import React from 'react';
import { Form, Input, message, Modal } from 'antd';

import EnvironmentSelect from '@lib/components/env-select';

type PropsType = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onSuccess?: (userId: string, environment: string) => void;
};

const AddDevelopAccountModal = (props: PropsType) => {
  const { isOpen, setIsOpen } = props;
  const [form] = Form.useForm();

  const closeModal = () => {
    form.resetFields();
    setIsOpen(false);
  };

  const handleOk = async () => {
    const formValues = form.getFieldsValue();

    if (!formValues.userId || !formValues.environment) {
      message.error('Please fill out all fields completely!!!');
      return;
    }

    if (props.onSuccess) {
      props.onSuccess(formValues.userId, formValues.environment);
    }

    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  return (
    <Modal title="Add Develop Account" visible={isOpen} onOk={handleOk} onCancel={handleCancel}>
      <Form form={form} labelCol={{ span: 7 }} wrapperCol={{ span: 17 }}>
        <Form.Item name="environment" label="Environment" required>
          <EnvironmentSelect />
        </Form.Item>
        <Form.Item name="userId" label="User ID" required>
          <Input placeholder="Enter user ID" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDevelopAccountModal;
